/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgPostHastag = ({ size }) => {
    return (<Svg
        viewBox="0 0 44.48 44.48"
        height={size}
        width={size}>
        <Path class="cls-1" fill = '#3382c4' d="M0,22.24A22.24,22.24,0,1,1,22.25,44.48,22.27,22.27,0,0,1,0,22.24ZM22.25,2.3a19.94,19.94,0,1,0,19.94,20A20,20,0,0,0,22.25,2.3Z" />
        <Rect class="cls-1" x="13.29" y="20.91" width="29.17" height="2.67" rx="1.27" ry="1.27" transform="translate(2.65 47.45) rotate(-83.55)" />
        <Rect class="cls-1" fill = '#3382c4' x="2.07" y="20.91" width="29.17" height="2.67" rx="1.27" ry="1.27" transform="translate(-7.31 36.29) rotate(-83.55)" />
        <Rect class="cls-1" x="9.66" y="15.88" width="26.39" height="2.67" rx="1.27" ry="1.27" />
        <Rect class="cls-1" fill = '#3382c4'  x="8.44" y="25.52" width="26.39" height="2.67" rx="1.27" ry="1.27" />
    </Svg>)
}

